module.exports = __webpack_public_path__ + "img/yuanjing.fbb71a98.png";